// store
import { atom } from 'recoil';

const appointmentFormAtom = atom<any | null>({
  key: 'appointmentFormAtom',
  default: null
});

export { appointmentFormAtom };
